import { useGetFF } from 'hooks/useGetFF';

const { Helmet } = require('react-helmet');

const TawkScript = () => {
  const { isEnabled } = useGetFF({ flag_id: 'tawk_integration' });

  if (!isEnabled) return null;
  return (
    <Helmet>
      <script type="text/javascript">
        {` var Tawk_API = Tawk_API || {},
          Tawk_LoadStart = new Date();
        (function () {
          var s1 = document.createElement('script'),
          s0 = document.getElementsByTagName('script')[0];
          s1.async = true;
          s1.src = 'https://embed.tawk.to/6829a65a5c188d190875ea40/1irhb3ks7';
          s1.charset = 'UTF-8';
          s1.setAttribute('crossorigin', '*');
          s0.parentNode.insertBefore(s1, s0);
        })();`}
      </script>
    </Helmet>
  );
};

export default TawkScript;
